import { useSelector } from "react-redux";
import deleteIcon from "../../../../../assets/Delete-icon.svg";
import editIcon from "../../../../../assets/Edit-icon.svg";
import duplicateIcon from "../../../../../assets/Duplicate-icon.svg";
import { getPaneIndex } from "../../../../../redux/constants";
import { Checkbox, Tag, Tooltip } from "antd";
import { SkeletonLoader } from "./SkeletonLoader";

export const QuickFilterTemplate = ({
  selectedCount,
  quickFilterChecked,
  handleTemplateCheckboxChange,
  handleDuplicateTemplate,
  handleEditTemplate,
  handleDeleteTemplate,
  filterTemplates,
  filterSearch,
}) => {
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeTabKey = useSelector((state) => state.Tab1.activeKey);

  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const All_Share_attributes = useSelector(
    (state) => state.WidgetMaker.All_Share_attributes
  );
  const templateLoader = useSelector((state) => state?.apiCall?.templateLoader);
  let allAttributesList = allAttributes ? allAttributes : All_WM_attributes;
  let index = getPaneIndex(panes, activeTabKey);

  return (
    <>
      <div
        style={{
          marginTop: `${filterTemplates.length > 5 ? "9.6rem" : "6.4rem"}`,
        }}
      >
        {!templateLoader && filterTemplates && filterTemplates.length > 5 && (
          <p className="max-filter-info box-shadow_bottom">
            You can select up to 5 Quick filters to pin on the dashboard.
          </p>
        )}
        {templateLoader ? (
          <SkeletonLoader />
        ) : (
          filterTemplates
            ?.filter((item) =>
              item?.filter_template_name
                ?.toLowerCase()
                .includes(filterSearch?.trim()?.toLowerCase() || "")
            )
            ?.map((template, index) => {
              return (
                <div
                  key={index}
                  style={{
                    border: "0.1rem solid #c3cbd7",
                    borderRadius: "2rem",
                    padding: "1.5rem",
                    marginRight: "0.8rem",
                    marginBottom: "0.8rem",
                    marginTop: "0.8rem",
                    transition: "border-color 0.3s",
                  }}
                  className="cursor-pointer"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.border =
                      "0.1rem solid rgb(24, 94, 223)";
                    const innerDiv =
                      e.currentTarget.querySelector(".action-buttons");
                    if (innerDiv) {
                      innerDiv.style.display = "flex";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.border = "0.1rem solid #c3cbd7";
                    const innerDiv =
                      e.currentTarget.querySelector(".action-buttons");
                    if (innerDiv) {
                      innerDiv.style.display = "none";
                    }
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      padding: "0rem 0.5rem",
                      justifyContent: "space-between",
                      // alignItems: "baseline",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <Tooltip
                        title={
                          selectedCount >= 5
                            ? "You can pin max 5 quick filters"
                            : ""
                        }
                      >
                        <Checkbox
                          checked={
                            quickFilterChecked[template.filter_template_id] ||
                            false
                          }
                          value={template.filter_template_id}
                          disabled={
                            !quickFilterChecked[template?.filter_template_id] &&
                            selectedCount >= 5
                          }
                          onChange={(e) =>
                            handleTemplateCheckboxChange(
                              e,
                              template.filter_template_id
                            )
                          }
                          className="text_regular d-block m-0 mb-2 line-height-normal d-flex align-items-start "
                        />
                      </Tooltip>
                      <div style={{ paddingLeft: "1rem", maxWidth: "34rem" }}>
                        <h5
                          className="text_heading-Slab font-weight500 d-inline-flex align-items-center"
                          style={{
                            overflowWrap: "anywhere",
                            maxWidth: "34rem",
                            fontSize: "1.5rem",
                            fontFamily: '"Roboto", sans-serif', //to apply Roboto-slab for consistency
                          }}
                        >
                          {" "}
                          {template?.filter_template_name}
                        </h5>
                        <p
                          style={{
                            overflowWrap: "anywhere",
                            color: "var(--locobuzz-primary-text-color)",
                          }}
                        >
                          {template?.filter_template_description}
                        </p>
                      </div>
                    </div>
                    <div className="action-buttons" style={{ display: "none" }}>
                      <Tooltip title="Duplicate and edit template">
                        <div
                          className="m-1 cursor-pointer"
                          onClick={() => handleDuplicateTemplate(template)}
                        >
                          <img src={duplicateIcon} alt="duplicate" />
                        </div>
                      </Tooltip>
                      <Tooltip title="Edit template">
                        <div
                          className="m-1 cursor-pointer"
                          onClick={() => handleEditTemplate(template)}
                        >
                          <img src={editIcon} alt="edit" />
                        </div>
                      </Tooltip>
                      <Tooltip title="Delete template">
                        <div
                          className="m-1 cursor-pointer"
                          onClick={() => handleDeleteTemplate(template)}
                        >
                          <img src={deleteIcon} alt="delete" />
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                  <div>
                    {template?.saved_filters?.slice(0, 5)?.map((tag, index) => (
                      <>
                        <Tag
                          key={index}
                          color="#5e708d"
                          style={{
                            borderRadius: "1.5rem",
                            marginBottom: "1rem",
                            padding: "0.4rem 0.8rem",
                          }}
                          className="ml-1 text_heading font-weight500 word-break quick-filter-panel-pills "
                        >
                          <span className="fontSize-14 font-weight500 w-100">
                            {All_Share_attributes
                              ? All_Share_attributes?.[tag?.attribute]
                                ? All_Share_attributes?.[tag?.attribute]
                                : tag?.attribute?.toLowerCase() === "categoryid"
                                ? "Category"
                                : tag?.attribute?.toLowerCase() ===
                                  "subcategoryid_aug"
                                ? "Sub Category"
                                : tag?.attribute?.toLowerCase() ===
                                  "subsubcategoryid"
                                ? "Sub Sub Category"
                                : tag?.attribute?.endsWith("ID")
                                ? tag?.attribute?.replace("ID", "")
                                : tag?.attribute?.replace("Type", "")
                              : tag?.attribute?.endsWith("ID")
                              ? tag?.attribute?.replace("ID", "")
                              : tag?.attribute?.replace("Type", "")}

                            {Array.isArray(tag?.columns) && ":"}
                            {!Array.isArray(tag?.columns) && ":"}
                          </span>
                          {/* show colon only if there is some valus in its columns to show aftr colon */}

                          <span className="fontSize-14 font-weight400 w-100">
                            {tag?.type === "int" &&
                              !Array.isArray(tag?.columns) && (
                                <span style={{ padding: "0 0.2rem" }}>
                                  {tag?.columns?.from +
                                    " - " +
                                    tag?.columns?.to}
                                </span>
                              )}
                            {Array.isArray(tag?.columns) &&
                              tag?.columns?.map((name, index) => {
                                return (
                                  <span
                                    key={index}
                                    style={{
                                      padding: "0 0.2rem",
                                      textWrap: "balance",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: `${
                                          name.type === "include"
                                            ? "rgb(94, 214, 109)"
                                            : name?.type === "exclude"
                                            ? "rgb(251, 118, 101)"
                                            : "#3b5175"
                                        }`,
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {(index ? ", " : "") +
                                        (name?.display_name
                                          ? name?.display_name
                                          : name?.name)}
                                    </span>
                                  </span>
                                );
                              })}
                          </span>
                        </Tag>
                      </>
                    ))}
                    {template?.saved_filters?.length > 5 && (
                      <Tooltip
                        overlayStyle={{
                          width: "18rem",
                        }}
                        color="#3B5175"
                        title={
                          template?.saved_filters?.slice(5).length > 0 ? (
                            <div
                              className="custom_scroll"
                              style={{
                                maxWidth: "27rem",
                                maxHeight: "23rem",
                                overflow: "auto",
                                scrollBehavior: "smooth",
                              }}
                            >
                              <div className="mb-1">
                                {template?.saved_filters?.slice(5).map((el) => {
                                  let data =
                                    panes[index]?.filterPanelData?.[
                                      el?.attribute
                                    ]?.values;

                                  return !(
                                    panes[index]?.template_id ===
                                      "000-000-002" ||
                                    panes[index]?.template_id === "000-000-003"
                                  ) ? (
                                    template?.saved_filters?.length ? (
                                      <div className="mb-2">
                                        <p
                                          className="mb-0"
                                          style={{
                                            color:
                                              el?.type === "include"
                                                ? "#5ed66d"
                                                : el?.type === "exclude"
                                                ? "#fb7665"
                                                : "#fff",
                                          }}
                                        >
                                          <strong>
                                            {All_Share_attributes
                                              ? All_Share_attributes?.[
                                                  el?.attribute
                                                ]
                                                ? All_Share_attributes?.[
                                                    el?.attribute
                                                  ]
                                                : el?.attribute?.toLowerCase() ===
                                                  "categoryid"
                                                ? "Category"
                                                : el?.attribute?.toLowerCase() ===
                                                  "subcategoryid_aug"
                                                ? "Sub Category"
                                                : el?.attribute?.toLowerCase() ===
                                                  "subsubcategoryid"
                                                ? "Sub Sub Category"
                                                : el?.attribute?.endsWith("ID")
                                                ? el?.attribute?.replace(
                                                    "ID",
                                                    ""
                                                  )
                                                : el?.attribute?.replace(
                                                    "Type",
                                                    ""
                                                  )
                                              : el?.attribute?.endsWith("ID")
                                              ? el?.attribute?.replace("ID", "")
                                              : el?.attribute?.replace(
                                                  "Type",
                                                  ""
                                                )}
                                          </strong>
                                        </p>
                                        {el?.type === "int" &&
                                          !Array.isArray(el?.columns) && (
                                            <span className="font-weight-light text-white">
                                              {el?.columns?.from +
                                                " - " +
                                                el?.columns?.to}
                                            </span>
                                          )}
                                        {Array.isArray(el?.columns) &&
                                          el?.columns?.map((e, index) => {
                                            return (
                                              <span
                                                className="font-weight-light"
                                                style={{
                                                  color:
                                                    e?.type === "include"
                                                      ? "#5ed66d"
                                                      : e?.type === "exclude"
                                                      ? "#fb7665"
                                                      : "#fff",
                                                }}
                                              >
                                                {(index ? ", " : "") +
                                                  (e?.display_name
                                                    ? e?.display_name
                                                    : e?.name)}
                                              </span>
                                            );
                                          })}
                                      </div>
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    <div className="mb-2">
                                      <p className="mb-0 text-white">
                                        <strong>
                                          {panes[index]?.template_id ===
                                            "000-000-003" &&
                                          el?.attribute === "IsWorkingHour"
                                            ? "Is Working Hour"
                                            : All_Share_attributes &&
                                              All_Share_attributes[
                                                el?.attribute?.toLowerCase()
                                              ]
                                            ? All_Share_attributes[
                                                el?.attribute?.toLowerCase()
                                              ]
                                            : panes[index]?.filterPanelData
                                            ? panes[index]?.filterPanelData?.[
                                                el?.attribute
                                              ]?.title
                                            : el?.attribute?.toLowerCase() ===
                                              "categoryid"
                                            ? "Category"
                                            : el?.attribute?.toLowerCase() ===
                                              "subcategoryid_aug"
                                            ? "Sub Category"
                                            : el?.attribute?.toLowerCase() ===
                                              "subsubcategoryid"
                                            ? "Sub Sub Category"
                                            : el?.attribute?.replace(
                                                "Type",
                                                ""
                                              )}
                                        </strong>
                                      </p>
                                      {Array.isArray(el?.columns) &&
                                        el?.columns?.map((e, index) => {
                                          return (
                                            <span
                                              className="font-weight-light"
                                              style={{
                                                color:
                                                  e?.type === "include"
                                                    ? "#5ed66d"
                                                    : e?.type === "exclude"
                                                    ? "#fb7665"
                                                    : "#fff",
                                              }}
                                            >
                                              {[
                                                "FeedBackEnabled",
                                                "ShowDeletedFromSocial",
                                                "AutoClosureEnabled",
                                                "IsWorkingHour",
                                              ]?.includes(el?.attribute)
                                                ? e?.name === null
                                                  ? "Any"
                                                  : e?.name === 0
                                                  ? "No"
                                                  : e?.name === 1 && "Yes"
                                                : (index ? ", " : "") +
                                                  data?.filter(
                                                    (g) => e?.name === g?.id
                                                  )[0]?.name}
                                            </span>
                                          );
                                        })}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          ) : (
                            ""
                          )
                        }
                        placement="leftTop"
                      >
                        <Tag
                          color="#5e708d"
                          style={{
                            borderRadius: "1.5rem",
                            marginBottom: "1rem",
                          }}
                          className="ml-1"
                        >
                          +{template?.saved_filters?.length - 5}
                        </Tag>
                      </Tooltip>
                    )}
                  </div>
                </div>
              );
            })
        )}
      </div>
    </>
  );
};
